import { IconFileSpreadsheet } from "@tabler/icons-react";
import { useState } from "react";
import { exportarExcel, type ColumnaExcel } from "@/shared/export/exportar-excel";
import { toastErrorApi, toastAdvertencia } from "@/lib/toast";
import { IconAction } from "./IconAction";

export interface BotonExportarExcelProps<T> {
  archivo: string;
  hoja?: string;
  columnas: ColumnaExcel<T>[];
  /** La tabla tiene todo en memoria · se exporta lo VISIBLE con los filtros aplicados. */
  filas?: T[];
  /** La tabla pagina en servidor · trae TODAS las páginas con los filtros actuales antes de exportar. */
  obtenerFilas?: () => Promise<T[]>;
  disabled?: boolean;
}

/** Reemplazo de `shared/export/BotonExportarExcel.tsx` (5+ usos) · misma lógica, sobre `IconAction` (Etapa 2). */
export function BotonExportarExcel<T>({ archivo, hoja, columnas, filas, obtenerFilas, disabled = false }: BotonExportarExcelProps<T>) {
  const [exportando, setExportando] = useState(false);

  async function exportar() {
    setExportando(true);
    try {
      const datos = obtenerFilas ? await obtenerFilas() : (filas ?? []);
      if (datos.length === 0) {
        toastAdvertencia({ title: "Nada que exportar", message: "No hay filas con los filtros actuales." });
        return;
      }
      exportarExcel({ archivo, hoja, columnas, filas: datos });
    } catch (err) {
      toastErrorApi(err);
    } finally {
      setExportando(false);
    }
  }

  return (
    <IconAction label="Exportar a Excel" variant="default" size="lg" onClick={() => void exportar()} loading={exportando} disabled={disabled}>
      <IconFileSpreadsheet size={16} stroke={1.7} />
    </IconAction>
  );
}
